module.exports = __webpack_public_path__ + "static/media/logo-icon.6a8e648f.svg";